import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import MobileContext from 'contexts/MobileContext';

export interface WithMobileProps {
    isMobile: boolean;
}

export default function withMobile<T extends WithMobileProps>(
    WrappedComponent: React.ComponentType<T>,
) {
    class WithMobile extends React.Component<Omit<T, keyof WithMobileProps>> {
        static displayName = `withMobile(${
            WrappedComponent.displayName || WrappedComponent.name || 'Component'
        })`;
        static contextType = MobileContext;

        render() {
            return <WrappedComponent {...(this.props as T)} isMobile={this.context} />;
        }
    }

    // Copies non-react specific statics from a child component to a parent component
    hoistNonReactStatics(WithMobile, WrappedComponent);
    return WithMobile;
}
